import { Pagination as MuiPagination } from '@mui/material';
import { PaginationProps } from '@mui/material/Pagination';
import { paginationItemClasses } from '@mui/material/PaginationItem';
import { styled } from '@mui/material/styles';

import { tokens } from '../../theme/styles/themeMui';

export type { PaginationProps };

export const Pagination = styled(MuiPagination)<PaginationProps>(({ theme }) => ({
  [`& .${paginationItemClasses.root}`]: {
    ...tokens.typography['body-s-regular'],
    color: theme.palette.colors.content.primary,
    borderRadius: '6px',
    minWidth: '32px',
    height: '32px',
    margin: '0 2px',
    [`&:hover`]: {
      backgroundColor: theme.palette.colors.bg['active-neutral-secondary'],
    },
  },
  [`& .${paginationItemClasses.selected}`]: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.colors.border.separator}`,
    [`&:hover`]: {
      backgroundColor: theme.palette.colors.bg['active-neutral-secondary'],
    },
  },
  [`& .${paginationItemClasses.previousNext}`]: {
    color: theme.palette.colors.content.primary,
    [`&.${paginationItemClasses.disabled}`]: {
      color: theme.palette.colors.content.tertiary,
    },
  },
  [`& .${paginationItemClasses.ellipsis}`]: {
    ...tokens.typography['body-s-regular'],
    color: theme.palette.colors.content.secondary,
  },
}));
